export enum DocShapeId {
  smartLock = 'product-detail',
  accessory = 'accessory',
  sparePart = 'spare-part',
  subscription = 'subscription',
  digitalProduct = 'virtual-product',
  pageTilesType = 'page-grid-type',
  structuralFolder = 'structural',
  dashboard = 'dashboard',
  bundle = 'bundle',
  productList = 'listing-page',
  faq = 'faq',
  anchorTile = 'anchor',
}
